import { render, staticRenderFns } from "./DispatchLocation.vue?vue&type=template&id=3e4a3b13&"
import script from "./DispatchLocation.vue?vue&type=script&lang=ts&"
export * from "./DispatchLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports